import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowRestore, faTachometerAlt, faImages } from '@fortawesome/free-solid-svg-icons';
import './Services.css';

const Services = () => {
    // Font Awesome Icon
    const cardIcon2 = <FontAwesomeIcon icon={faWindowRestore} />
    const cardIcon3 = <FontAwesomeIcon icon={faTachometerAlt} />
    const cardIcon6 = <FontAwesomeIcon icon={faImages} />
    return (
        <>
            <section className="services">
                <div className="container py-5">
                    <h1 className="text-center text-light py-3 services-header-title">My Awesome Service</h1>
                </div>
                <Container>
                    <Row xs={1} md={3} className="g-4 pb-5">
                
                        <Col>
                            <Card className="services-card">
                                <Card.Body>
                                    <Card.Text className="d-flex flex-column flex-md-row justify-content-between"> <p style={{ fontSize: '50px', color: 'tomato' }}>{cardIcon2}</p></Card.Text>
                                    <Card.Text className="d-flex flex-column flex-md-row justify-content-between"><p className="card-title">Web Development</p>
                                    </Card.Text>
                                    <Card.Text className="d-flex flex-column flex-md-row justify-content-between"><p className="card-description">I throw myself down among the tall grass by the stream as I lie close to the earth.</p>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className="services-card">
                                <Card.Body>
                                    <Card.Text className="d-flex flex-column flex-md-row justify-content-between"> <p style={{ fontSize: '50px', color: 'tomato' }}>{cardIcon3}</p></Card.Text>
                                    <Card.Text className="d-flex flex-column flex-md-row justify-content-between"><p className="card-title">WordPress</p>
                                    </Card.Text>
                                    <Card.Text className="d-flex flex-column flex-md-row justify-content-between"><p className="card-description">I throw myself down among the tall grass by the stream as I lie close to the earth.</p>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className="services-card">
                                <Card.Body>
                                    <Card.Text className="d-flex flex-column flex-md-row justify-content-between"> <p style={{ fontSize: '50px', color: 'tomato' }}>{cardIcon6}</p></Card.Text>
                                    <Card.Text className="d-flex flex-column flex-md-row justify-content-between"><p className="card-title">Basic Photoshop</p>
                                    </Card.Text>
                                    <Card.Text className="d-flex flex-column flex-md-row justify-content-between"><p className="card-description">I throw myself down among the tall grass by the stream as I lie close to the earth.</p>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default Services;